<template>
    <div :class="['identityContent',identity == '0' ? 'authentication' : '']">
        <div class="identityTitle">我的身份</div>
        <!-- 未认证 -->
        <template v-if="identity == '0'">
            <div class="identityList flex">
                <div :class="['identityBox align',active == index ? 'identityBoxOn' : '']" v-for="(item,index) in identityData" :key="index" @click="active = index">
                    <el-image :src="active == index ? require('@/assets/icon/radioOn.png') : require('@/assets/icon/radio.png')" fit="cover" class="radio"></el-image>
                    <div class="name">{{ item.name }}</div>
                    <el-image :src="item.img" fit="cover" class="identityImg"></el-image>
                </div>
            </div>
            <div class="inforBox flex">
                <div class="inforTitle"><span>*</span>上传营业执照:</div>
                <el-upload action="/api/common/upload" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="removeLicense" :on-success="uploadLicense" :limit="1" ref="uploadImage" :file-list="licenseFileList">
                    <i class="el-icon-upload"></i>
                </el-upload>
            </div>
            <div class="inforBox flex">
                <div class="inforTitle"><span>*</span>您的公司名称:</div>
                <el-input placeholder="请输入您的公司名称" v-model="company" class="identityIpt"></el-input>
            </div>
            <div class="inforBox flex">
                <div class="inforTitle"><span>*</span>联系方式:</div>
                <el-input placeholder="请填写您的手机号码/微信号" v-model="phone" class="identityIpt"></el-input>
            </div>
            <div class="inforBox flex">
                <div class="inforTitle"><span>*</span>上传微信二维码:</div>
                <el-upload action="/api/common/upload" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="removeCode" :on-success="uploadCode" :limit="1" :file-list="codeFileList">
                    <i class="el-icon-upload"></i>
                </el-upload>
            </div>
            <div class="inforBox flex" style="padding-top: 87px;">
                <div class="inforTitle"></div>
                <div class="inforBtn" @click="inforBtnTap">提交</div>
            </div>
            <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </template>
        <template v-if="identity == '1'">
            <div class="align">
                <div class="through">
                    <div class="between" style="padding: 26px 0;">
                        <div class="align">
                            <el-image :src="require('@/assets/icon/radioOn.png')" fit="cover" class="throughIcon"></el-image>
                            <div class="throughName">您已通过{{identityObj.name}}身份认证</div>
                        </div>
                        <div class="throughBtn" @click="throughBtnTap">更改身份</div>
                    </div>
                    <div class="between" style="padding-right: 12px;">
                        <div class="throughData">
                            <div class="flex">
                                <div class="title">平台身份：{{ identityData[identityObj.type].name }}</div>
                            </div>
                            <div class="flex">
                                <div class="title">公司名称：{{ identityObj.company }}</div>
                            </div>
                        </div>
                        <el-image :src="identityData[identityObj.type].img" fit="cover" class="throughImg"></el-image>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                userDetail: 0,
                active: 0,
                identityData: [
                    {
                        name: '商家',
                        img: require('@/assets/icon/identity01.png')
                    },
                    {
                        name: '服务商',
                        img: require('@/assets/icon/identity02.png')
                    },
                    {
                        name: '达人',
                        img: require('@/assets/icon/identity03.png')
                    }
                ],
                company: '',
                phone: '',
                dialogImageUrl: '',
                dialogVisible: false,
                identity: '',
                identityObj: {},
                code: '',
                license: '',
                modify: false,
                codeFileList: [],
                licenseFileList: []
            }
        },
        watch: {
			code: {
                handler: function handler(e) {
                    if(e != ''){
                        let arr = [{url: e}]
                        this.codeFileList = arr
                    }
                },
                immediate: true,
                deep: true
			},
            license: {
                handler: function handler(e) {
                    if(e != ''){
                        let arr = [{url: e}]
                        this.licenseFileList = arr
                    }
                },
                immediate: true,
                deep: true
			}
		},
        created(){
            this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
            this.getIdentity()
        },
        methods: {
            // 获取身份
            getIdentity(){
                this.request.get("index/user/renzheng",{
                    params:{
                        userid: this.userDetail.userid
                    }
                })
                .then(res=>{
                    this.identity = res.code
                    if(res.code){
                        this.identityObj = res.data
                    }
                })
            },
            // 获取已认证信息
            getIdentityInfo(){
                this.request.get("index/user/renzhenginfo",{
                    params:{
                        id: this.identityObj.id
                    }
                })
                .then(res=>{
                    this.active = res.data.type
                    this.company = res.data.company
                    this.phone = res.data.contact
                    this.code = res.data.code
                    this.license = res.data.license
                })
            },
            uploadCode(response, file, fileList){
                console.log(response, file, fileList);
                this.code = response.data.fullurl
            },
            uploadLicense(response, file, fileList){
                console.log(response, file, fileList);
                this.request.get("index/user/identify",{
                    params:{
                        ImageUrl: response.data.fullurl
                    }
                })
                .then(res=>{
                    if(res.code && res.code == '1'){
                        this.company = res.data
                        this.license = response.data.fullurl
                    }else{
                        this.$message.error(res.data);
                        this.$refs.uploadImage.clearFiles()
                    }
                })
            },
            removeCode(file, fileList) {
                console.log(file, fileList);
                this.code = ''
            },
            removeLicense(file, fileList) {
                console.log(file, fileList);
                this.code = ''
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            // 提交
            inforBtnTap(){
                if(this.company == '' || this.phone == '' || this.code == '' || this.license == ''){
                    this.$message({
                        message: '请填写完整信息',
                        type: 'warning'
                    });
                }else{
                    this.request.get("index/user/renzhengedit",{
                        params:{
                            userid: this.userDetail.userid,
                            type: this.active,
                            company: this.company,
                            contact: this.phone,
                            code: this.code,
                            license: this.license,
                            id: this.identityObj.id
                        }
                    })
                    .then(res=>{
                        if(res.code){
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            this.company = this.phone = this.code = this.license = ''
                            this.codeFileList = this.licenseFileList = []
                            this.getIdentity()
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                }
            },
            // 更改身份
            throughBtnTap(){
                this.identity = 0
                this.modify = true
                this.getIdentityInfo()
            }
        }
    }
</script>
<style lang="less" scoped>
    .authentication{
        width: 904px !important;
        margin: 0 auto;
    }
    .identityContent{
        width: 100%;
        padding-bottom: 230px;
        .identityTitle{
            font: 20px/20px "Microsoft YaHei";
            color: #606263;
            padding-top: 20px;
        }
        .identityList{
            padding-bottom: 38px;
            .identityBox{
                width: 286px;
                height: 96px;
                border: 1px solid #F7F8FA !important;
                background: #F7F8FA;
                border-radius: 10px;
                margin: 20px 20px 0 0;
                cursor: pointer;
                &:last-child{
                    margin-right: 0;
                }
                .radio{
                    width: 18px;
                    height: 18px;
                    margin-left: 20px;
                }
                .name{
                    width: 80px;
                    font: 20px/20px "Microsoft YaHei";
                    color: #1D2129;
                    padding: 0 14px;
                }
                .identityImg{
                    width: 104px;
                    height: 104px;
                }
            }
            .identityBoxOn{
                border: 1px solid #FE7513 !important;
                background: #FFFAF6 !important;
            }
        }
        .inforBox{
            margin-top: 30px;
            .inforTitle{
                width: 290px;
                font: 14px/40px "Microsoft YaHei";
                color: #464646;
                text-align: right;
                padding-right: 24px;
                span{
                    color: #FF6C04;
                }
            }
            .identityIpt{
                width: 338px;
                height: 38px;
            }
            .inforBtn{
                width: 240px;
                height: 48px;
                background: #FF6A00;
                border-radius: 4px;
                font: 15px/48px "Microsoft YaHei";
                color: #fff;
                text-align: center;
                cursor: pointer;
            }
        }
        .through{
            padding: 10px 26px 27px 28px;
            background: #F7F8FA;
            border-radius: 10px;
            margin-top: 18px;
            .throughIcon{
                width: 18px;
                height: 18px;
            }
            .throughName{
                font: 18px/18px "Microsoft YaHei";
                color: #FF6A00;
                padding: 0 70px 0 8px;
            }
            .throughBtn{
                padding: 0 9px;
                font: 14px/30px "Microsoft YaHei";
                color: #FF6A00;
                border: 1px solid #FF6A00;
                border-radius: 16px;
                cursor: pointer;
            }
            .throughData{
                padding-right: 56px;
                .title{
                    font: 16px/30px "Microsoft YaHei";
                    color: #606263;
                    border-bottom: 1px solid #E7E7E8;
                }
            }
            .throughImg{
                width: 104px;
                height: 104px;
            }
        }
    }
</style>